import { type IHubspotWorkflowStatistic } from 'entities/HubspotWorkflows/api/types'
import { Statistic } from 'entities/ContactStatistic/model/Statistic'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class HubspotWorkflowStatistics extends Statistic {
  constructor(
    {
      opt_out_count,
      no_replies_count,
      reply_count,
      success_count,
      total_count,
      undelivered_count,
      clicks,
      quiet_hours_count,
    }: IHubspotWorkflowStatistic,
    private _entities?: IEntitiesStore
  ) {
    super({
      unsubscribed_count: opt_out_count,
      no_replies_count,
      reply_count,
      success_count,
      total_count,
      undelivered_count,
      clicks_count: clicks,
      quiet_hours_count,
    })
  }

  get filters() {
    return this.getFilters(
      {
        sent_to: {
          tooltipLabel: 'Total messages sent',
        },
        quiet_hours: {
          tooltipLabel: 'Messages delayed by quiet hours',
        },
        success: {
          tooltipLabel: 'Messages that were successfully sent',
        },
        replied: {
          tooltipLabel: 'Messages that got a reply',
        },
        no_replies: {
          tooltipLabel: 'Messages that got no response',
        },
        clicked: {
          tooltipLabel: 'Messages with link clicks',
        },
        failed: {
          tooltipLabel: 'Messages that failed to send',
        },
      },
      this._entities
    )
  }
}
